const { VITE_APP_SHOULD_LOG_DEBUG_AND_INFO_LOGS_TO_CONSOLE } = import.meta.env;
const NUM_LOG_MESSAGES_LIMIT = 7500;
const NUM_OLD_LOG_MESSAGE_TO_CLEAR_AT_A_TIME = 20;
const LOG_LEVEL_DEBUG = 'debug';
const LOG_LEVEL_INFO = 'info';
const LOG_LEVEL_WARN = 'warn';
const LOG_LEVEL_ERROR = 'error';

export default class Logger {
  shouldLogDebugAndInfoLogsToConsole = VITE_APP_SHOULD_LOG_DEBUG_AND_INFO_LOGS_TO_CONSOLE === 'true';
  logs: any[] = [];
  logLevel: typeof LOG_LEVEL_DEBUG | typeof LOG_LEVEL_INFO | typeof LOG_LEVEL_WARN | typeof LOG_LEVEL_ERROR = LOG_LEVEL_INFO;

  clearOldLogs() {
    if (this.logs.length < NUM_LOG_MESSAGES_LIMIT) {
      return;
    }

    this.logs = this.logs.slice(NUM_OLD_LOG_MESSAGE_TO_CLEAR_AT_A_TIME);
  }

  debug(...args: any[]) {
    if (![LOG_LEVEL_DEBUG].includes(this.logLevel)) {
      return;
    }

    if (this.shouldLogDebugAndInfoLogsToConsole) {
      console.debug(...args);
    }

    this.clearOldLogs();

    this.logs.push({
      level: LOG_LEVEL_DEBUG,
      timeStamp: Date.now(),
      messages: [...args]
    });
  }

  info(...args: any[]) {
    if (![LOG_LEVEL_DEBUG, LOG_LEVEL_INFO].includes(this.logLevel)) {
      return;
    }

    if (this.shouldLogDebugAndInfoLogsToConsole) {
      console.info(...args);
    }

    this.clearOldLogs();

    this.logs.push({
      level: LOG_LEVEL_INFO,
      timeStamp: Date.now(),
      messages: []
    });
  }

  warn(...args: any[]) {
    if (![LOG_LEVEL_DEBUG, LOG_LEVEL_INFO, LOG_LEVEL_WARN].includes(this.logLevel)) {
      return;
    }

    console.warn(...args);

    this.clearOldLogs();

    this.logs.push({
      level: LOG_LEVEL_WARN,
      timeStamp: Date.now(),
      messages: [...args]
    });
  }

  error(...args: any[]) {
    console.error(...args);

    this.clearOldLogs();

    this.logs.push({
      level: LOG_LEVEL_ERROR,
      timeStamp: Date.now(),
      messages: [...args]
    });
  }
}
